import { render, staticRenderFns } from "./Badges.vue?vue&type=template&id=7ce9b585&scoped=true"
import script from "./Badges.vue?vue&type=script&lang=ts"
export * from "./Badges.vue?vue&type=script&lang=ts"
import style0 from "./Badges.vue?vue&type=style&index=0&id=7ce9b585&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ce9b585",
  null
  
)

export default component.exports